import {BaseModel} from './BaseModel';

export class ValidityModel extends BaseModel {
    validateProperty (property, attributes) {
        if (!attributes[property]) {
            return {
                property,
                message: ''
            };
        }
    }
}


// WEBPACK FOOTER //
// ./shared/model/base/ValidityModel.js